var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2243",
    "data-name": "Group 2243",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 394,
    height: 394,
    viewBox: "0 0 394 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 195.843,
    cy: 195.843,
    r: 195.843,
    fill: "#21b537"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M197,0C305.8,0,394,88.2,394,197S305.8,394,197,394,0,305.8,0,197,88.2,0,197,0Z",
    fill: "#1589d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(1.157 1.157)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 82.575,
    cy: 82.575,
    rx: 82.575,
    ry: 82.575,
    transform: "translate(111.404 84.274)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M937.333,648.649c-31.817,28.1-71.328,43.383-112.037,43.339H619.368L638.9,631.695c9.157-22.215,28.647-37.025,50.675-38.5l12.648-.859,30.16-28.779s81.264-3.211,80.058-4.748l49.224,32.758-.04-.226,19.35,1.311c22.03,1.471,41.524,16.282,50.675,38.5Z",
    transform: "translate(-578.182 -299.217)",
    fill: "#1c3b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M817.635,604.293q.866-10.05.792-20.16a102.69,102.69,0,0,0-6.552-38.859,57.178,57.178,0,0,0-28.6-30.183,48.093,48.093,0,0,0-39.119.037A74.756,74.756,0,0,0,707,500.349c-13.556-1.188-26.787,4.948-35.424,16.425a62.847,62.847,0,0,1-6.189,8.785c-6.563,6.64-16.538,5.683-25.262,4.324q5.868,5.5,11.741,10.993l-14.21,4.056,16.582,10.988c-16.046,10.524-23.341,33.491-21.415,54.352,1.823,19.749,10.55,37.808,20.983,53.859,4.161-9.595,3.265-21.076,3.2-31.883a78.726,78.726,0,0,1,.586-10.483c35.256,9.234,72.1,15.16,109.454.495l7.5-20.048c1.052.119,2.1.229,3.156.352l4.343,19.714c9.847,4.4,19.715,8.24,29.588,4.2.48,3.044.769,6.152.992,9.139.846-3.574,1.582-7.172,2.244-10.786a29.183,29.183,0,0,0,3.737-2.609A95.8,95.8,0,0,0,817.635,604.293Z",
    transform: "translate(-536.531 -475.26)",
    fill: "#2f2e41"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(77.422 34.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M5.574-34.723V-5.785A19.3,19.3,0,0,0,24.851,13.492H44.2l.009-67.538H24.86A19.307,19.307,0,0,0,5.574-34.723Z",
    transform: "translate(-5.574 162.136)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M97.594-54.047H78.243v67.5H97.594A19.3,19.3,0,0,0,116.871-5.823V-34.761A19.286,19.286,0,0,0,97.594-54.047Z",
    transform: "translate(117.255 162.136)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M81.24-11.727H60.546A12.159,12.159,0,0,0,48.394.425,12.159,12.159,0,0,0,60.546,12.576H81.24A12.159,12.159,0,0,0,93.392.425,12.135,12.135,0,0,0,81.24-11.727Z",
    transform: "translate(89.527 198.623)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M29.613,5.673c0-44.667,29.946-88.537,87.348-88.217s92.952,43.552,92.952,88.217l-7.2,11.6h23.623V5.673c0-57.392-47.692-104.142-106.344-104.142S13.651-51.721,13.651,5.673v11.6H37.274Z",
    transform: "translate(-2.929 98.469)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M102.377-21.537A41.166,41.166,0,0,1,71.591,11.056a22.075,22.075,0,0,1,.364,3.469,21.56,21.56,0,0,1-1.119,6.547,50.831,50.831,0,0,0,41.379-42.936,28.363,28.363,0,0,1-4.309.364h-5.53Z",
    transform: "translate(106.978 184.557)",
    fill: "#eceff1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSupport);
export default __webpack_public_path__ + "static/media/userSupport.139fb1c7508a44cffd996465558f4e36.svg";
export { ForwardRef as ReactComponent };